<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <defs>
  </defs>
  <path class="cls-2" d="m24.63,35.8l5.6,21.34c.16.6-.2,1.21-.8,1.37h0s3.71,14.13,3.71,14.13c.17.65-.22,1.32-.86,1.49l-5.25,1.38c-.65.17-1.31-.22-1.48-.86l-3.56-13.57c-.08-.31-.39-.5-.71-.43-5.12.98-10.23-2.19-11.57-7.3l-1.1-4.2c-1.4-5.33,1.82-10.84,7.15-12.23l7.43-1.95c.63-.17,1.28.21,1.45.85Z"/>
  <path class="cls-2" d="m33.57,52.75l-4.24-16.14c-.17-.63.08-1.3.61-1.67l28.88-20.2c.89-.62,2.13-.17,2.4.88l10.28,39.16c.27,1.04-.56,2.04-1.63,1.95l-34.92-2.82c-.66-.05-1.21-.52-1.38-1.16Z"/>
  <path class="cls-1" d="m73.39,18.62s11.93,9.75,7.24,27.57"/>
  <path class="cls-1" d="m68.99,25.44s7.62,6.39,4.46,16.98"/>
</svg>
</template>

<script>
export default {
    name: "PromotionsIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: none;
    stroke: #b3decd;
    stroke-linecap: round;
    stroke-width: 1.5px;
  }
  .cls-1, .cls-2 {
    stroke-miterlimit: 10;
  }
  .cls-2 {
    fill: #59c5c7;
    stroke: #135d73;
    stroke-width: 2px;
  }
</style>